import type { IServiceMap } from '../services';

export const CampaignManagementServicesGoogleAdGrant: IServiceMap = {
  setup: {
    accountAndWorkspaceSetup: false,
    pixelInstallationUpTo3Domains: false,
    groupCreation: 0,
    customDataRequests: 1,
    conversionPixels: 0,
    contactRecordImports: 0,
    dataImportAndListCleaning: false,
  },
  calls: {
    dedicatedFlightManagementTeam: false,
    quarterlyReview: false,
    kickOffAndFinalReport: false,
    liveTrainingSessions: 0,
    liveStrategist: false,
    dedicatedSupportRep: false,
  },
  implementations: {
    implementationsPageVisible: true,
  },
  creatives: {
    credits: 0,
    creativeABTesting: false,
    starterSet: false,
  },
  execution: {
    flightSetupAndManagement: false,
    biweeklyHealthChecks: false,
    liveCampaignReportLinks: false,
    reusableFlightTemplate: false,
    formattedFinalReport: false,
  },
};
